module.exports = __webpack_public_path__ + "static/media/verification.eaaab9f5.png";